// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import { FormGroup, Col, ControlLabel } from 'react-bootstrap';

export default class FormGroupView extends Component {

  static Label = ({ children }) => {
    return (
      <div>
        {children}
      </div>
    )
  }

  static Content = ({ children }) => {
    return (
      <div>
        {children}
      </div>
    )
  }

  getComponent(key: string) {
    return this.props.children.filter( (comp) => {
      return comp.key === key;
    });
  }

  // see https://react-bootstrap.github.io/components.html#forms
  // TODO: find better way for children
  render() {
    try {
    return (
      <FormGroup
        controlId={this.props.name}
      >
        <Col componentClass={ControlLabel} sm={4}>
          {!_.isNil(this.props.children[0]) && this.props.children[0]}
        </Col>
        <Col sm={8} md={6} lg={4}>
          {!_.isNil(this.props.children[1]) && this.props.children[1]}
        </Col>
      </FormGroup>
      ); } catch (e) { console.error(e); }
  }

}
